import { useContext } from 'react';
import Highcharts, { Point } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import "highcharts/modules/accessibility";

import { Grid2 as Grid, Avatar, Box, Card, CardContent, CardHeader, Typography, Alert, Link} from '@mui/material';
import { amber, blue } from '@mui/material/colors';
import { FilersDataContext } from '../../../Filers';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';


const FinancialSummary = (): JSX.Element => {

    const filerDataContext = useContext(FilersDataContext);
    const ytdReport = filerDataContext.currentFilerPayload?.ytdReport;
    
    const viewMoreData = () => {
        filerDataContext.setContentType('Contributions');
    }

    //prepare data for the chart
    const chartData = [
        ytdReport?.startBalanceNumeric ?? null,
        ytdReport?.receiptsYtdNumeric ?? null,
        ytdReport?.expendituresYtdNumeric ?? null,
        ytdReport?.currentCashOnHandNumeric ?? null
    ];
    const chartLabels = ['Start Balance', 'Receipts YTD', 'Expenditures YTD', 'Cash On Hand'];
    const chartColors = ['#42a5f5','#0FCCC9','#edc949','#42a5f5'];
    const noActivity = chartData.every((value) => value === 0);

    const financialSummaryChartOptions = {
      chart: {
          type: 'bar',
          height: 350,
      },
      colors: chartColors,
      title: {
        text: "",
      },
      tooltip: {
          valueDecimals: 2,
          valuePrefix: '$'
      },
      xAxis: {
          categories: chartLabels,
          title: {
              text: null
          },
          labels: {
              style: {
                  fontSize: '13px',
                  color: 'black',
                  fontWeight: '550'
              },
          },
          min: 0,
          lineWidth: 0,
          gridLineWidth: 0,
          lineColor: 'transparent',
          minorTickLength: 0,
          tickLength: 0
      },
      yAxis: {
          min: 0,
          title: {
              text: '',
              align: 'high'
          },
          labels: {
              overflow: 'justify'
          },
          lineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: 'transparent'
      },
      plotOptions: {
          bar: {
              dataLabels: {
                  enabled: true,
                  style: {
                      fontWeight: 'bold'
                  },
                  format: '${point.y:,.2f}'
              },
              cursor: 'pointer',
              colorByPoint: true,
              point: {
                  events: {
                      //click: updateGridData
                  }
              }
          }
      },
      legend: {
          enabled: false
      },
      credits: {
          enabled: false
      },
      exporting: {
          enabled: false
      },
      series: [
          {
              name: 'Financial Summary',
              data: chartData
          }
      ]
    };

    return (
        <Grid size={{ xs: 12, md: 5.5 }} marginTop={2} data-aos={'fade-up'}>
          <Card 
            //variant="outlined"
            //sx={{ height: '100%' }}
            sx={{
                "&:hover": {
                    boxShadow: "0 0 10px #ccc",
                },
                borderTop: `2px solid`,
                borderTopColor: amber[700],
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                height: '100%',
              }}
            data-aos={'fade-up'}
            >
            <CardHeader
                avatar={
                <Avatar sx={{ bgcolor: blue[500] }} className="small-avatar">
                    <AttachMoneyIcon fontSize="small" />
                </Avatar>}
                padding={1}
                title={
                    <Typography
                    variant="h6">
                    Financial Summary: {new Date().getFullYear()} YTD
                    </Typography>
                }                                                      
            />                                                   
            <CardContent className="card-content">
                <Grid container alignContent="center" justifyContent="space-between">
                    {     
                        noActivity?
                        <Box>
                          <Alert icon={false} severity="warning">
                            This filer hasn't filed any financial reports yet in the current year.
                          </Alert>
                        </Box>:
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={financialSummaryChartOptions}
                        /> 
                    }
                    {
                        !noActivity &&
                        <Grid size={12} display="flex" justifyContent="flex-end" marginTop={2}>
                            <Link className='is-clickable' onClick={viewMoreData} underline='none' fontSize={"small"}><i>View More Data</i></Link>
                        </Grid>
                    }
                </Grid>  
            </CardContent>                                               
          </Card>
        </Grid>
    );
  };

export default FinancialSummary;